export default __webpack_public_path__ + "static/media/terrain.eec5b9b5.png";